import Vuex from "vuex";
import axios from "axios";
// function getToken() {}
export default new Vuex.Store({
  state: {
    appName: "mila",
    baseUrl: "https://milashop.ir/panel/api",
    // baseUrl: "http://192.168.1.3:8080/mila_l11/api",
    baseUrl_taxi: "https://iranbanotaxi.ir/api",
    show: false,
    device: "",
    _token: "",
    _token_taxi: "",
    snackbar: {
      text: "",
      color: "",
      timeout: 5000,
    },
    auth: {
      loggedIn: false,
    },
    auth_taxi: [],
    current_service_info: [],
    totalItems: 0,
    c_set: [],
    taxi_c_set: [],
    loading_site: false,
  },
  getters: {
    device: function (state) {
      return state.device;
    },
    baseUrl: function (state) {
      return state.baseUrl;
    },
    baseUrl_taxi: function (state) {
      return state.baseUrl_taxi;
    },
    appToken: function (state) {
      return state._token;
    },

    appToken_taxi: function (state) {
      return state._token_taxi;
    },
    auth: function (state) {
      return state.auth;
    },

    auth_taxi: function (state) {
      return state.auth_taxi;
    },
    totalItems(state) {
      return state.totalItems;
    },
    c_set: function (state) {
      return state.c_set;
    },

    taxi_c_set: function (state) {
      return state.taxi_c_set;
    },
    current_service_info: function (state) {
      return state.current_service_info;
    },
  },
  mutations: {
    SET_TOTAL_ITEMS(state, total) {
      state.totalItems = total;
    },
    setDevice(state, payload) {
      state.device = payload;
    },

    setToken(state, payload) {
      state._token = payload;
      localStorage.setItem("_token", JSON.stringify(payload));
    },

    setToken_taxi(state, payload) {
      console.log("ssss");
      state._token_taxi = payload;
      localStorage.setItem("_token_taxi", JSON.stringify(payload));
    },
    setAuth(state, payload) {
      state.auth = payload;
      localStorage.setItem("auth", JSON.stringify(payload));
      state.auth.loggedIn = true;
    },

    setAuth_taxi(state, payload) {
      state.auth_taxi = payload;
      localStorage.setItem("auth_taxi", JSON.stringify(payload));
    },
    checkToken(state) {
      const token = localStorage.getItem("_token");
      if (token) state._token = JSON.parse(token);
      else localStorage.removeItem("_token");
    },

    checkToken_taxi(state) {
      const token = localStorage.getItem("_token_taxi");
      if (token) state._token_taxi = JSON.parse(token);
      else localStorage.removeItem("_token_taxi");
    },

    checkAuth(state) {
      const auth = localStorage.getItem("auth");
      if (auth) {
        state.auth = JSON.parse(auth);
        state.auth.loggedIn = true;
      }
      //اگر به هر دلیلی storage auth حذف شد میاد اینجا
      else {
        axios
          .post(
            state.baseUrl + "/getUser",
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + state._token,
              },
            }
          )
          .then((r) => {
            if (r.data.result == "1") {
              state.auth = r.data;
              localStorage.setItem("auth", JSON.stringify(r.data));
              state.auth.loggedIn = true;
            } else {
              localStorage.removeItem("_token");
            }
          })
          .catch(function () {
            localStorage.removeItem("_token");
          });
      }
    },

    checkAuth_taxi(state) {
      const auth = localStorage.getItem("auth_taxi");
      if (auth) state.auth_taxi = JSON.parse(auth);
    },
    logout(state) {
      let obj = { loggedIn: false };
      localStorage.setItem("auth", JSON.stringify(obj));
      state.auth = obj;
    },
    optionSet(state, payload) {
      state.c_set = payload;
      localStorage.setItem("c_set", JSON.stringify(payload));
    },

    check_optionSet(state) {
      const auth = localStorage.getItem("c_set");
      if (auth) {
        state.c_set = JSON.parse(auth);
      }
    },

    taxi_optionSet(state, payload) {
      state.taxi_c_set = payload;
      localStorage.setItem("taxi_c_set", JSON.stringify(payload));
    },

    taxi_check_optionSet(state) {
      const auth = localStorage.getItem("taxi_c_set");
      if (auth) {
        state.taxi_c_set = JSON.parse(auth);
      }
    },

    current_service_set(state, payload) {
      state.current_service_info = payload;
    },
  },
  actions: {
    toast: function (context, payload) {
      context.commit("toast", payload);
    },
    checkToken({ commit }) {
      commit("checkToken");
    },

    checkToken_taxi({ commit }) {
      commit("checkToken_taxi");
    },
    checkAuth({ commit }) {
      commit("checkAuth");
    },
    checkAuth_taxi({ commit }) {
      commit("checkAuth_taxi");
    },

    check_optionSet({ commit }) {
      commit("check_optionSet");
    },

    taxi_check_optionSet({ commit }) {
      commit("taxi_check_optionSet");
    },
    updateTotalItems({ commit }) {
      const basket = JSON.parse(localStorage.getItem("basket")) || [];
      commit("SET_TOTAL_ITEMS", basket);
    },
  },
  modules: {},
});
